module.exports = __webpack_public_path__ + "static/img/c_caozuoxinxi.506ee81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/c_caozuoxinxi.png
// module id = u9XJ
// module chunks = 70